import React, { useEffect, useState } from "react";
import NoDataFound from "../common/NoDataFound";
import { loadStyles } from "../../utils/cssLoader";

const TennisRankings = ({
  data,
  loadCSS = true,
  dataClient = false,
  title,
}) => {
  const [clientData, setClientData] = useState(null);

  useEffect(() => {
    if (!dataClient) return;
    const container = document?.querySelector(".microservice-cont");
    const raw = container?.getAttribute("data-listingdata");
    if (!raw) return;

    try {
      const parsed = JSON.parse(raw)?.data?.data;
      setClientData(parsed || null);
    } catch (err) {
      console.error("Failed to parse data-listingdata:", err);
    }
  }, [dataClient]);

  useEffect(() => {
    if (loadCSS === "true") {
      loadStyles("tennisrankings");
    }
  }, [loadCSS]);

  const rankingData = dataClient ? clientData : data;

  if (!rankingData || !Array.isArray(rankingData) || rankingData.length === 0) {
    return <NoDataFound />;
  }

  return (
    <div className="tennis_rankings_container">
      {title && <h1>{title}</h1>}
      <div className="global_table ranking_tbl">
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Player</th>
              <th>Age</th>
              <th>+/-</th>
              <th>TP</th>
              <th>Drop.</th>
              <th>NB</th>
            </tr>
          </thead>
          <tbody>
            {rankingData.map((item, index) => (
              <tr key={item.id || index}>
                <td>{item.rank || item.id || index + 1}</td>
                <td>{item.player || item.name || item.nm || "-"}</td>
                <td>{item.age || "-"}</td>
                <td className={item.plusMinus?.includes("+") ? "positive" : item.plusMinus?.includes("-") ? "negative" : ""}>
                  {item.plusMinus || item.plus_minus || "-"}
                </td>
                <td>{item.totalPoints || item.tp || item.tournaments_played || "-"}</td>
                <td>{item.dropPoints || item.drop || item.dropping || "-"}</td>
                <td>{item.netPoints || item.nb || item.next_best || "-"}</td>
              </tr>
            ))}
            <tr>
              <td colSpan={7}>
                <ul className="ranking_list">
                  <li><span>OP</span> <strong>Official Points</strong></li>
                  <li><span>Drop.</span><strong>Dropping</strong></li>
                  <li><span>TP</span><strong>Tourn Played</strong></li>
                  <li><span>NB</span><strong>Next Best</strong></li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TennisRankings;
